const r = (e) => e.replace(/^www\./, "");
export {
  r as replaceWwwForHosts
};
